export default "__VITE_ASSET__cSmEDQ_I__"